module.exports = __webpack_public_path__ + "static/media/Picture1.7fe375aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Picture1.png
// module id = 619
// module chunks = 0